export default "__VITE_ASSET__D321_Nm3__"